<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <form>
        <h5 class="description">Prix total</h5>
          <Input
            v-model="minBudgetPT"
            datatype="number"
            placeholder="Min"
            @change="inputs"
          />  
        
        <Input
          v-model="maxBudgetPT"
          datatype="number"
          placeholder="Max"
          @change="inputs"
        />
        <h5 class="description">Prix au m²</h5>
        <Input
          v-model="minBudgetPM"
          datatype="number"
          placeholder="Min"
          @change="inputs"
        />
        <Input
          v-model="maxBudgetPM"
          datatype="number"
          placeholder="Max"
          @change="inputs"
        />
        <button type="button" class="btn" @click="change">Valider</button>
      </form>
    </div>
  </div>
</template>
<script>
import Input from "./Input";
//import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  mounted(){
   
  },
  data() {
    return {
      minBudgetPT:null,
      maxBudgetPT:null,
      minBudgetPM:null,
      maxBudgetPM:null,
    };
  },
  props: {
    show: {
      type: Boolean
    },
    MinBudgetPT: {
      type: Number
    },
    MaxBudgetPT: {
      type: Number
    },
    MinBudgetPM: {
      type: Number
    },
    MaxBudgetPM: {
      type: Number
    },
  },
  methods: {
    change() {
      this.$emit('change', {minBudgetPT: this.minBudgetPT, maxBudgetPT: this.maxBudgetPT, minBudgetPM: this.minBudgetPM, maxBudgetPM: this.maxBudgetPM})
    },
    inputs(){
      this.$emit('budgets', {minBudgetPT: this.minBudgetPT, maxBudgetPT: this.maxBudgetPT, minBudgetPM: this.minBudgetPM, maxBudgetPM: this.maxBudgetPM} )
    }
  },
  components: {
    Input,
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    MinBudgetPT(value) {
      this.minBudgetPT = value
    },
    MaxBudgetPT(value) {
      this.maxBudgetPT = value
    },
    MinBudgetPM(value) {
      this.minBudgetPM = value
    },
    MaxBudgetPM(value) {
      this.maxBudgetPM = value
    },
  },
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  .modal {
    width: 100%;
    width: 100%;
    background-color: #f2fdff;
    border-radius: 5px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    margin-top: 15px;
    .description {
      margin: 0px;
      margin-bottom: 10px;
      color: #22ABC5;
      font-size: 15px;
      font-weight: normal;
    }
    .btn {
      width: 100%;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #22abc5;
      padding: 12px;
      outline: 0;
      margin-top: 15px;
      font-family: Metropolis;
      font-size: 15px;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .modal-backdrop {
  position: initial;
  }
 
}
@media screen and (max-width: 375px) {
  .modal-backdrop {
  .modal{
    width: 150px;
  }
  }
}
</style>
